const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class Rats extends Event {
    constructor(){
        super(
            Age.Age1,
            EventNames.Rats,
            "Each civilization loses all stored food.",
            {}
        )
    }
}

module.exports = Rats;